import { render, staticRenderFns } from "./ProfileSubscriptionsCard.vue?vue&type=template&id=13517002"
import script from "./ProfileSubscriptionsCard.vue?vue&type=script&lang=js"
export * from "./ProfileSubscriptionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports